import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

interface NavItem {
  label: string;
  route: string;
  icon: string;
  /** Lit only on this exact route; off for pages with sub-routes (P&L Explain's mapping, the explorer's tabs). */
  exact: boolean;
}

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss']
})
export class SideNavComponent {
  isIframe = false;

  readonly items: NavItem[] = [
    { label: 'Home', route: '/', icon: 'home', exact: true },
    { label: 'Gantt', route: '/gantt', icon: 'view_timeline', exact: true },
    { label: 'Input Compare', route: '/comparisons', icon: 'difference', exact: true },
    { label: 'MTI Compare', route: '/mti-comparison', icon: 'bar_chart', exact: true },
    { label: 'P&L Explain', route: '/pnl-explain', icon: 'query_stats', exact: false },
    { label: 'TBTU Inputs vs LIOS', route: '/feasibility-checks', icon: 'fact_check', exact: true },
    { label: 'IM Outputs Explorer', route: '/explorer', icon: 'explore', exact: false },
  ];

  constructor(router: Router) {
    // Phones: the drawer closes once a page is picked.
    router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe(() => document.body.classList.remove('nav-open'));
  }

  trackRoute(_: number, item: NavItem): string { return item.route; }

  /** A tap on the dimmed page beside the open drawer closes it. */
  closeIfBackdrop(e: Event): void { if (e.target === e.currentTarget) document.body.classList.remove('nav-open'); }
}
